import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";
import { hasStaffContentAccess, isSuperAdmin } from "./roleUtils";
import { isLocalDev } from "./devAuth";

export const DEMO_FAN_PREVIEW_UID = "demo_fan_001";

export function canUseAdminSeedPreview(userProfile) {
  if (!userProfile) return false;
  if (isSuperAdmin(userProfile)) return true;
  return isLocalDev() && hasStaffContentAccess(userProfile);
}

function dropTimestamp(drop) {
  const t = drop?.createdAt;
  if (!t) return 0;
  if (typeof t.seconds === "number") return t.seconds;
  if (t instanceof Date) return t.getTime() / 1000;
  return 0;
}

export function normalizeCreator(creatorId, data) {
  return {
    id: creatorId,
    ...data,
    avatarUrl: data.avatarUrl || data.avatar || "",
    handle: data.handle || data.username || "",
  };
}

export async function fetchLatestDropForCreator(creatorId) {
  const dropSnap = await getDocs(
    query(collection(db, "drops"), where("creatorId", "==", creatorId), limit(50))
  );
  if (dropSnap.empty) return null;

  const drops = dropSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
  drops.sort((a, b) => dropTimestamp(b) - dropTimestamp(a));
  return drops[0];
}

async function findSeedPurchasedDrop(followingIds) {
  for (const creatorId of followingIds) {
    const dropSnap = await getDocs(
      query(
        collection(db, "drops"),
        where("creatorId", "==", creatorId),
        where("accessType", "==", "paid")
      )
    );
    if (!dropSnap.empty) {
      return [dropSnap.docs[0].id];
    }
  }
  return [];
}

/**
 * Loads demo_fan_001's following / subscriptions / purchasedDrops so staff
 * can preview the Home feed against seed data without a separate fan login.
 */
export async function loadAdminSeedPreview() {
  const demoSnap = await getDoc(doc(db, "users", DEMO_FAN_PREVIEW_UID));
  if (demoSnap.exists()) {
    const data = demoSnap.data();
    if (Array.isArray(data.following) && data.following.length > 0) {
      return {
        following: data.following,
        subscriptions: data.subscriptions || [],
        purchasedDrops: data.purchasedDrops || [],
        previewSourceUid: DEMO_FAN_PREVIEW_UID,
      };
    }
  }

  const creatorsSnap = await getDocs(
    query(
      collection(db, "users"),
      where("isCreator", "==", true),
      where("isSeedData", "==", true),
      limit(6)
    )
  );

  const following = creatorsSnap.docs.map((d) => d.id);
  if (following.length === 0) {
    return {
      following: [],
      subscriptions: [],
      purchasedDrops: [],
      previewSourceUid: null,
    };
  }

  const purchasedDrops = await findSeedPurchasedDrop(following);

  return {
    following,
    subscriptions: following.length > 1 ? [following[1]] : [],
    purchasedDrops,
    previewSourceUid: DEMO_FAN_PREVIEW_UID,
  };
}
